import { render } from "./FavoriteIcon.vue?vue&type=template&id=72bbaeb0"
const script = {}
script.render = render

export default script